import {
  EyeStroke,
  FileMultipleStroke,
  FilePlusCircleStroke,
  Pencil1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { groupTypes } from '../../nhom-phi';

/**
 * Props for the ActionBar component
 */
interface ActionBarProps {
  isViewDisabled?: boolean;
  onAddClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onCopyClick?: () => void;
  onViewClick?: () => void;
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportClick?: () => void;
  onExportExcelClick?: () => void;
  onImportExcelClick?: () => void;
  activeGroup?: string;
}

/**
 * ActionBar component for the Balance Sheet by Unit page
 */
const ActionBar: React.FC<ActionBarProps> = ({
  isViewDisabled = false,
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onViewClick,
  onSearchClick,
  onFixedColumnsClick,
  onRefreshClick,
  onExportClick,
  onExportExcelClick,
  onImportExcelClick,
  activeGroup
}) => {
  const activeGroupInfo = groupTypes.find(group => group.value === activeGroup);
  const displayText = activeGroupInfo
    ? `Phân nhóm: ${activeGroupInfo.shortCode} - ${activeGroupInfo.label}`
    : 'Phân nhóm: PH - Nhóm phi (PH)';

  return (
    <ActionBarV2
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Danh mục phân nhóm</h1>
          <span className='flex items-center justify-start text-xs font-semibold text-gray-500'>
            <div className='mr-2 size-2 rounded-full bg-red-500' />
            Phân nhóm: {displayText}
          </span>
        </div>
      }
    >
      {onAddClick && <ActionButtonV2 icon={FilePlusCircleStroke} title='Thêm' onClick={onAddClick} />}
      {onEditClick && (
        <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isViewDisabled} />
      )}
      {onDeleteClick && (
        <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} disabled={isViewDisabled} />
      )}
      {onCopyClick && (
        <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyClick} disabled={isViewDisabled} />
      )}
      {onViewClick && <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} disabled={isViewDisabled} />}

      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Tìm kiếm',
            icon: <AritoIcon icon={12} />,
            onClick: onSearchClick,
            group: 1
          },
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick,
            group: 2
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: onFixedColumnsClick,
            group: 2
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: onExportClick,
            group: 3
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: onExportExcelClick,
            group: 4
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportExcelClick,
            group: 4
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
